import {
  hideFloatLevelSettingsModal,
  showFloatLevelSettingsModal,
  showSuccessAlert,
} from "@actions/modals";
import Kiosk from "@api/kiosk";
import OptionsList from "@components/systemAdmin/OptionsList";
import { getOptionValue } from "@helpers/options";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Icon, Modal } from "semantic-ui-react";

class FloatLevelSettingsModal extends Component {
  closeModal = () => this.props.hideFloatLevelSettingsModal();

  onOptionChange = (key, option, value) => {
    const floatControls = [...this.props.data[key]];
    const index = floatControls.findIndex(
      (control) => control.code === option.code,
    );
    floatControls[index] = option;
    this.props.showFloatLevelSettingsModal({ [key]: floatControls });
  };

  getChanged = () => {
    const { maximumFloats, lowFloats } = this.props.data;
    let changed = {};

    maximumFloats.forEach((x) => {
      if (x.isEditable) changed[x.code] = getOptionValue(x);
    });

    lowFloats.forEach((x) => {
      if (x.isEditable) changed[x.code] = getOptionValue(x);
    });

    return changed;
  };

  handleSave = () => {
    const { installationId } = this.props.data;
    const changed = this.getChanged();

    Kiosk.UpdateFloats(installationId, changed).then((result) => {
      this.props.showSuccessAlert(result, "Success", this.closeModal);
    });
  };

  render() {
    const { maximumFloats, lowFloats, game, open } = this.props.data;

    return (
      <Modal open={open} size="large" centered={false}>
        <Modal.Header>
          <Header size="tiny">
            Kiosk Float Level Settings
            <Header.Subheader>{game}</Header.Subheader>
          </Header>
        </Modal.Header>
        <Modal.Content>
          <Grid columns={2} stackable>
            <Grid.Row>
              <Grid.Column>
                <Form>
                  <OptionsList
                    options={maximumFloats}
                    onChange={async (option, value) =>
                      this.onOptionChange("maximumFloats", option, value)
                    }
                  />
                </Form>
              </Grid.Column>
              <Grid.Column>
                <Form>
                  <OptionsList
                    options={lowFloats}
                    onChange={async (option, value) =>
                      this.onOptionChange("lowFloats", option, value)
                    }
                  />
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.closeModal} color="red">
            Cancel
          </Button>
          <Button onClick={this.handleSave} color="green" disabled={false}>
            <Icon name="save" />
            Save Changes
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.floatLevelSettingsModal,
  };
};

export default connect(mapStateToProps, {
  showFloatLevelSettingsModal,
  hideFloatLevelSettingsModal,
  showSuccessAlert,
})(FloatLevelSettingsModal);
